import { render } from "./TransitionWidth.vue?vue&type=template&id=423bbde4&scoped=true&ts=true"
import script from "./TransitionWidth.vue?vue&type=script&lang=ts"
export * from "./TransitionWidth.vue?vue&type=script&lang=ts"

import "./TransitionWidth.vue?vue&type=style&index=0&id=423bbde4&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423bbde4"]])

export default __exports__